import { Button, Form, Modal } from '@mairistem/composants';
import React from 'react';
import type LigneNotePresentation from '../../../../../interfaces/simulation/ligneNotePresentation';

interface UpdateModalProps {
	onClose: VoidFunction;
	onSave: (ligne: LigneNotePresentation) => void;
	ligne: LigneNotePresentation;
	loading?: boolean;
	open: boolean;
}

const UpdateModal: React.FC<UpdateModalProps> = ({
	onClose,
	onSave,
	ligne,
	loading = false,
	open,
}) => {
	const [updatedLigne, setUpdatedLigne] =
		React.useState<LigneNotePresentation>(ligne);

	React.useEffect(() => {
		setUpdatedLigne(ligne);
	}, [ligne]);

	const handleChangeUpdatedLigne = (
		e: React.ChangeEvent<
			HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
		>,
	) => {
		const { name, value } = e.target;
		setUpdatedLigne((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleSave = () => {
		if (updatedLigne !== ligne) {
			onSave(updatedLigne);
		} else {
			onClose();
		}
	};

	return (
		<Modal size="small" onClose={onClose} open={open}>
			<Modal.Header>
				Modification du bloc
				{ligne?.codeBlock && ` « ${ligne.codeBlock} »`}
			</Modal.Header>
			<Modal.Content>
				<Form>
					<Form.Input
						input={{ 'data-testid': 'titreInput' }}
						label="Titre du bloc"
						name="titre"
						required
						onChange={handleChangeUpdatedLigne}
						value={updatedLigne?.titre ?? ''}
					/>
					<Form.Input
						input={{ 'data-testid': 'contenuCourtInput' }}
						label="Contenu court du bloc"
						name="contenuCourt"
						required
						onChange={handleChangeUpdatedLigne}
						value={updatedLigne?.contenuCourt ?? ''}
					/>
					<Form.TextArea
						data-testid="contenuLongInput"
						label="Contenu long du bloc"
						name="contenuLong"
						required
						rows={6}
						onChange={handleChangeUpdatedLigne}
						value={updatedLigne?.contenuLong ?? ''}
					/>
				</Form>
			</Modal.Content>
			<Modal.Actions>
				<Button
					content="Annuler"
					data-testid="cancelButton"
					onClick={onClose}
					disabled={loading}
				/>
				<Button
					content="Valider"
					data-testid="confirmButton"
					onClick={handleSave}
					positive
					loading={loading}
				/>
			</Modal.Actions>
		</Modal>
	);
};

export default UpdateModal;
